import React, { useEffect } from "react";
import { SelectDevices } from "./SelectDevices";

const TITLE = "GPS sensors";

export const GPS_ID = "gps";

const GPSDeviceData = [
  {
    id: GPS_ID,
    label: "GPS",
  },
];

const SelectGPSDevices = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  useEffect(() => {
    loadingDevices.add(1);
    onChange(GPSDeviceData);
    loadingDevices.done();
  }, []);
  return (
    <SelectDevices
      title={TITLE}
      data={GPSDeviceData}
      selectedDevices={selectedDevices}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default SelectGPSDevices;
